
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authentication/password-recovery",
      function () {
        return require("private-next-pages/authentication/password-recovery.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authentication/password-recovery"])
      });
    }
  